import React, { useState, useEffect } from 'react';
import { FModal } from '@components';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { formatToBRL } from 'brazilian-values';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="customGraphTooltip">
        <p>
          <p className="label">{payload[0].name}: </p>
          {formatToBRL(payload[0].value || 0)}
        </p>
        <p>
          <p className="label">{payload[1].name}: </p>
          {formatToBRL(payload[1].value || 0)}
        </p>
      </div>
    );
  }

  return null;
};

export const Modal = ({ modalIsOpen, setModalIsOpen, data }) => {
  const [graphData, setGraphData] = useState({
    beneficioMax: 0,
    vitalicioMax: 0,
    graphData: [],
  });

  useEffect(() => {
    const graph = data.map((d) => {
      return {
        idade: `${d.idade}`,
        beneficio: Number(d.valorBeneficio),
        saldo: Number(d.saldoInicial),
      };
    });

    const arrayBeneficios = graph.map((d) => {
      return Object.values({ beneficio: d.beneficio })[0];
    });

    const valorMaxBeneficio = Math.max(...arrayBeneficios) * 1.2;
    const valorMaxVitalicio = graph.vitalicio * 1.2;

    setGraphData({
      idadeMin: graph[0].idade,
      idadeMax: graph[graph.length - 1].idade,
      beneficioMax: valorMaxBeneficio,
      vitalicioMax: valorMaxVitalicio,
      graph,
    });
  }, []);

  return (
    <FModal
      isOpen={modalIsOpen}
      close
      widthAuto
      onClose={() => setModalIsOpen(false)}
    >
      <>
        <div className="tbsuccessOptionWrapper">
          <h1 className="ts-20 fw-bold mb-1">
            Simulação - Evolução do Saldo de Contas e Benefício
          </h1>
        </div>

        <div className="graphLegend">
          <p>Valor de benefício</p>
          <p>Saldo de contas</p>
        </div>

        <div className="graphSimulator">
          <ResponsiveContainer
            className="graphLabel"
            width="100%"
            height={400}
            pa
          >
            <LineChart data={graphData.graph}>
              <CartesianGrid strokeDasharray="6 6" />
              <XAxis
                dataKey="idade"
                domain={[graphData.idadeMin, graphData.idadeMax]}
              />
              <YAxis
                tickFormatter={(value) => formatToBRL(value)}
                domain={[0, graphData.beneficioMax]}
                yAxisId={1}
                angle={0}
                width={100}
              />
              <YAxis
                orientation="right"
                tickFormatter={(value) => formatToBRL(value)}
                domain={[0, graphData.vitalicioMax]}
                yAxisId={2}
                width={120}
                height="100%"
              />
              <Line
                yAxisId={1}
                type="linear"
                name="Benefício simulado"
                dataKey="beneficio"
                stroke="#8884d8"
                animationDuration={600}
              />
              <Line
                yAxisId={2}
                type="linear"
                name="Saldo de contas"
                dataKey="saldo"
                stroke="#e87400"
                animationDuration={600}
              />
              <Legend />
              <Tooltip content={<CustomTooltip />} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </>
    </FModal>
  );
};
